var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIconOnRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2673 0.939453C18.9337 0.939453 19.543 1.31598 19.841 1.91205L24.3784 10.9869L34.3555 12.4381C35.0182 12.5345 35.5687 12.9987 35.7756 13.6356C35.9825 14.2724 35.81 14.9715 35.3305 15.439L28.0691 22.5189L29.7026 32.5012C29.8105 33.1609 29.5353 33.8248 28.9922 34.2146C28.4491 34.6045 27.7321 34.6529 27.1415 34.3395L18.2673 29.6307L9.39307 34.3395C8.80255 34.6529 8.08548 34.6045 7.5424 34.2146C6.99933 33.8248 6.72409 33.1609 6.83204 32.5012L8.46551 22.5189L1.20408 15.439C0.72462 14.9715 0.552089 14.2724 0.759011 13.6356C0.965932 12.9987 1.51643 12.5345 2.17909 12.4381L12.1562 10.9869L16.6936 1.91205C16.9916 1.31598 17.6009 0.939453 18.2673 0.939453Z",
    fill: "#F46940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconOnRed);
export default __webpack_public_path__ + "static/media/starIconOnRed.70ee4ff1c9451f34e3e2031af570a683.svg";
export { ForwardRef as ReactComponent };